module.exports = __webpack_public_path__ + "static/media/visibility-24px.e5b7cb1c.svg";